import { render } from "./LbrxNotePopup.vue?vue&type=template&id=c60f3d5e&scoped=true"
import script from "./LbrxNotePopup.vue?vue&type=script&lang=js"
export * from "./LbrxNotePopup.vue?vue&type=script&lang=js"

import "./LbrxNotePopup.vue?vue&type=style&index=0&id=c60f3d5e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60f3d5e"]])

export default __exports__